import {EventStep} from '~/CreateFabricInvitation/components/NavHeader/types';

export const isEventStep = (value: unknown): value is EventStep => {
  return typeof value === 'object' && value !== null && 'id' in value;
};

export const getRawSteps = (steps: Record<string, unknown>): Record<string, EventStep> => {
  return Object.fromEntries(
    Object.entries(steps).filter(([_, value]) => isEventStep(value))
  ) as Record<string, EventStep>;
};
